import type { RxJsonSchema } from 'rxdb'

/**
 * ChecklistItem Document Type (Denormalized for RxDB)
 */
export interface ChecklistItemDocument {
  id: string
  envId: string
  checklistId: string
  content: string
  isCompleted: boolean
  sortOrder: string | null
  isDeleted: boolean

  // Audit fields
  createdOn: number
  createdBy: string
  updatedOn: number
  updatedBy: string
  deletedOn: number | null
  deletedBy: string | null

  // RxDB replication metadata
  updatedAt?: number
}

/**
 * RxDB Schema for ChecklistItem
 */
export const checklistItemSchema: RxJsonSchema<ChecklistItemDocument> = {
  version: 1,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 36,
    },
    envId: {
      type: 'string',
      maxLength: 36,
    },
    checklistId: {
      type: 'string',
      maxLength: 36,
    },
    content: {
      type: 'string',
    },
    isCompleted: {
      type: 'boolean',
      default: false,
    },
    sortOrder: {
      type: ['string', 'null'],
      maxLength: 100,
    },
    isDeleted: {
      type: 'boolean',
      default: false,
    },

    // Audit fields
    createdOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    createdBy: {
      type: 'string',
      maxLength: 36,
    },
    updatedOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    updatedBy: {
      type: 'string',
      maxLength: 36,
    },
    deletedOn: {
      type: ['number', 'null'],
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    deletedBy: {
      type: ['string', 'null'],
      maxLength: 36,
    },

    // RxDB replication metadata
    updatedAt: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
  },
  required: [
    'id',
    'envId',
    'checklistId',
    'content',
    'isCompleted',
    'isDeleted',
    'createdOn',
    'createdBy',
    'updatedOn',
    'updatedBy',
  ],
  // sortOrder dropped from indexes — RxDB does not support indexes on nullable fields.
  indexes: [
    'envId',
    'checklistId',
    'updatedOn',
    ['checklistId', 'isDeleted'],
  ],
}

export const checklistItemMigrationStrategies = {
  // v0 -> v1: sortOrder relaxed to nullable to match backend (string?).
  // Mirror of the moly-mobile fix.
  1: (oldDoc: any): any => oldDoc,
}
